import { render, staticRenderFns } from "./EditSobity.vue?vue&type=template&id=28578769&scoped=true&"
import script from "./EditSobity.vue?vue&type=script&lang=js&"
export * from "./EditSobity.vue?vue&type=script&lang=js&"
import style0 from "./EditSobity.vue?vue&type=style&index=0&id=28578769&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28578769",
  null
  
)

export default component.exports